import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import HomePage from './HomePage'
import FaqPage from './FAQPage'
import TermsPage from './TermsPage'
import SubscribePage from './SubscribePage'

const App = () => {
  const router=createBrowserRouter([
    {
      path:"/",
      element:<HomePage />
    },
    {
      path:"/terms",
      element:<TermsPage />
    },
    {
      path:"/faq",
      element:<FaqPage />
    },
    {
      path:"/subscribe",
      element:<SubscribePage />
    }
  ])
  return (
    <RouterProvider router={router} />
  )
}

export default App